import { getParametrizedUrl } from '@x_x_x/utils';

import { URLS_API } from '@constants';

import { BaseApi, IRequestOptions } from '../BaseApi';

import {
	IApiZeppSettingsRequestParams,
	IApiZeppSettingsRequestBody,
	IApiZeppSettingsResponseData,

	IApiZeppSyncRequestParams,
	IApiZeppSyncRequestBody,
	IApiZeppSyncResponseData,
} from './types';

export class ZeppApi extends BaseApi {

	async updateSettings(options: IRequestOptions<IApiZeppSettingsRequestParams, IApiZeppSettingsRequestBody>) {
		const { body } = options;

		return this.put<IApiZeppSettingsRequestBody, IApiZeppSettingsResponseData>({
			url: getParametrizedUrl(URLS_API.ZEPP_SETTINGS),
			data: body,
		});
	}

	async sync(options: IRequestOptions<IApiZeppSyncRequestParams, IApiZeppSyncRequestBody>) {
		const { body } = options;

		return this.post<IApiZeppSyncRequestBody, IApiZeppSyncResponseData>({
			url: getParametrizedUrl(URLS_API.ZEPP_SYNC),
			data: body,
		});
	}

}
